
import { defineComponent } from '@vue/composition-api';
import Text from './Text.vue';

export default defineComponent({
  extends: Text
});
